import React, {
  useEffect,
  useState,
} from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
  FaFileDownload,
  FaFileAlt,
} from "react-icons/fa";

const Documents = () => {
  const [open, setOpen] =
    useState(false);

  const [data, setData] =
    useState([]);

  useEffect(() => {
    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/documents"
    )
      .then((res) =>
        res.json()
      )
      .then(setData);
  }, []);

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <section className="relative overflow-hidden bg-gradient-to-r from-[#072F5F] via-[#0B4F9C] to-[#072F5F] py-20 md:py-28">

        {/* BACKGROUND */}
        <div className="absolute inset-0 opacity-10">

          <div className="absolute top-0 left-0 w-72 h-72 bg-white rounded-full blur-3xl"></div>

          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D4A017] rounded-full blur-3xl"></div>

        </div>

        <div className="relative max-w-7xl mx-auto px-5 md:px-10 text-center">

          <div className="w-20 h-20 rounded-3xl bg-white/10 backdrop-blur-md flex items-center justify-center text-white text-3xl mx-auto shadow-2xl">

            <FaFileAlt />

          </div>

          <span className="inline-block mt-6 text-[#D4A017] uppercase tracking-[5px] text-sm font-bold">

            School Records

          </span>

          <h1 className="text-4xl md:text-6xl font-extrabold text-white mt-5">

            Homeworks

          </h1>

          <p className="text-gray-200 text-lg mt-6 max-w-3xl mx-auto leading-8">

            Access and download important
            school documents, notices and
            official files easily.

          </p>

        </div>

      </section>

      {/* DOCUMENT SECTION */}
      <section className="w-full bg-[#f7f9fc] py-16 md:py-24 overflow-x-hidden">

        <div className="max-w-6xl mx-auto px-5 md:px-10">

          {/* TITLE */}
          <div className="text-center mb-14">

            <span className="text-[#D4A017] uppercase tracking-[5px] text-sm font-bold">

              Downloads

            </span>

            <h2 className="text-4xl md:text-5xl font-extrabold text-[#072F5F] mt-4">

              Downloads

            </h2>

            <div className="w-24 h-1 bg-[#D4A017] rounded-full mx-auto mt-6"></div>

          </div>

          {/* TABLE CARD */}
          <div className="bg-white rounded-[35px] shadow-xl border border-gray-100 overflow-hidden">

            {/* TOP BAR */}
            <div className="h-3 bg-gradient-to-r from-[#072F5F] via-[#0B4F9C] to-[#D4A017]"></div>

            {/* TABLE */}
            <div className="overflow-x-auto">

              <table className="w-full min-w-[700px]">

                <thead className="bg-[#072F5F] text-white">

                  <tr>

                    <th className="text-left px-8 py-5 text-lg font-semibold">

                      Document Name

                    </th>

                    <th className="text-center px-8 py-5 text-lg font-semibold">

                      Action

                    </th>

                  </tr>

                </thead>

                <tbody>

                  {data.length > 0 ? (
                    data.map((d, index) => (
                      <tr
                        key={d.id}
                        className={`border-b border-gray-100 hover:bg-[#f7f9fc] transition-all duration-300 ${
                          index % 2 === 0
                            ? "bg-white"
                            : "bg-gray-50/50"
                        }`}
                      >

                        {/* TITLE */}
                        <td className="px-8 py-6">

                          <div className="flex items-center gap-4">

                            <div className="w-12 h-12 rounded-xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-lg shrink-0">

                              <FaFileAlt />

                            </div>

                            <p className="text-[#072F5F] font-semibold text-[16px]">

                              {d.title}

                            </p>

                          </div>

                        </td>

                        {/* DOWNLOAD */}
                        <td className="px-8 py-6 text-center">

                          <a
                            href={`https://stjosephweb.ilakshyaerp.in/uploads/documents/${d.file}`}
                            target="_blank"
                            rel="noreferrer"
                            download
                            className="inline-flex items-center gap-3 bg-[#0B4F9C] hover:bg-[#072F5F] text-white px-6 py-3 rounded-2xl font-semibold transition-all duration-300 shadow-lg hover:-translate-y-1"
                          >

                            <FaFileDownload />

                            Download

                          </a>

                        </td>

                      </tr>
                    ))
                  ) : (
                    <tr>

                      <td
                        colSpan="2"
                        className="text-center py-16"
                      >

                        <div className="flex flex-col items-center">

                          <div className="w-20 h-20 rounded-full bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-3xl mb-6">

                            <FaFileAlt />

                          </div>

                          <h3 className="text-3xl font-extrabold text-[#072F5F]">

                            No Homework Available

                          </h3>

                          <p className="text-gray-500 mt-4 text-lg">

                            Uploaded Homework will
                            appear here soon.

                          </p>

                        </div>

                      </td>

                    </tr>
                  )}

                </tbody>

              </table>

            </div>

          </div>

        </div>

      </section>

      <Footer />
    </>
  );
};

export default Documents;